import { Transform } from '@warp-drive/legacy/serializer/transform';
import moment from 'moment';

export default class SqlDateTimeTransform extends Transform {
  deserialize(serialized) {
    if (!serialized) {
      return null;
    }

    const dateTime = moment(serialized, 'YYYY-MM-DD HH:mm:ss');

    return dateTime.isValid() ? dateTime.toDate() : null;
  }

  serialize(date) {
    if (!date) {
      return null;
    }

    const dateTime = moment(date);

    return dateTime.isValid() ? dateTime.format('YYYY-MM-DD HH:mm:ss') : null;
  }
}
